import { render, staticRenderFns } from "./merkeztanitim.vue?vue&type=template&id=f2ed8a64&"
import script from "./merkeztanitim.vue?vue&type=script&lang=js&"
export * from "./merkeztanitim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports